<template>
  <div v-if="callout" :class="$style.container">
    <div>{{ callout.created | date('Pp') }}</div>
    <div :class="$style.title">{{ title }}</div>
    <div :class="$style.mediaWrap">
      <img
        v-if="mediaType === 'IMAGE'"
        :src="mediaLink" :alt="'Image: ' + title"
        :class="$style.image"
      >
      <video
        v-else-if="mediaType === 'VIDEO'"
        :src="mediaLink"
        controls
        preload="metadata"
        :class="$style.video"
      ></video>
    </div>
    <p :class="$style.text">{{ text }}</p>
    <a
      v-if="button && button.link"
      :href="button.link"
      target="_blank"
      :class="$style.buttonLink"
    >
      <BaseButton>{{ button.label }}</BaseButton>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'callout-post',
  props: {
    id: [String, Number]
  },
  async created () {
    if (this.callout) return
    await this.fetchCallouts()
    if (!this.callout) {
      this.$router.replace({ name: 'callouts' })
    }
  },
  computed: {
    ...mapGetters({
      getCallout: 'entities/callouts/find'
    }),
    callout () {
      return this.getCallout(Number(this.id))
    },
    title () {
      return this.callout.payload.advertising.title
    },
    text () {
      return this.callout.payload.advertising.text
    },
    mediaType () {
      return this.callout.payload.advertising.mediaType
    },
    mediaLink () {
      return this.callout.payload.advertising.mediaLink
    },
    button () {
      return this.callout.payload.advertising.button
    }
  },
  methods: {
    ...mapActions({
      fetchCallouts: 'entities/callouts/fetch'
    })
  }
}
</script>

<style module lang="scss">
.container {
  padding: 20px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.title {
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 500;
  margin: 10px 0;
}
.mediaWrap {
  text-align: center;
}
.image {
  margin: 0 auto;
  max-width: 100%;
  max-height: 450px;
  object-fit: contain;
}
.video {
  margin: 0 auto;
  max-width: 100%;
  max-height: 450px;
}
.text {
  margin-top: 12px;
  &:first-letter {
    font-size: 40px;
    font-weight: 500;
  }
}
</style>
